export default "__VITE_ASSET__52ee135b__"